import CXMApiClient from "../CXMApiClient";
import { csv, HelperFunctions } from "../../lib/utilities/HelperFunctions";
import { CountryCodes } from "@/lib/utilities/enums";

async function canadianStoreCheck(accountPlatformId) {
  return new Promise((resolve) => {
    HelperFunctions.getOrLoadPlatformSettings(
      accountPlatformId
    ).then((value) => {
      resolve((value && value.CountryID == CountryCodes.Canada));
    });
  });
}

async function mapResponse(response) {
  if (!response || !response.data || !response.data.length) return response;
  const isCanadianStore = await canadianStoreCheck(response.data[0].accountPlatformId);

  response.data = response.data.map(result => {
    const currentSaleType = (result.currentSaleType || '').toLowerCase();
    if (currentSaleType.startsWith('lease')) {
      if (isCanadianStore) {
        result.additionalReturnFields.rate = (Number(result.additionalReturnFields.rate) * 2400).toFixed(2);
        result.additionalReturnFields.replacementrate = (Number(result.additionalReturnFields.replacementrate) * 2400).toFixed(2);
      } else {
        result.additionalReturnFields.rate = (Number(result.additionalReturnFields.rate)).toFixed(5);
        result.additionalReturnFields.replacementrate = Number(result.additionalReturnFields.replacementrate).toFixed(5);
      }
    } else {
      result.additionalReturnFields.rate = (Number(result.additionalReturnFields.rate)).toFixed(2);
      result.additionalReturnFields.replacementrate = Number(result.additionalReturnFields.replacementrate).toFixed(2);
    }

    return result;
  });

  return response;
}

function initialState() {
  return {
    OpportunityFields: [],
    OpportunityAdvancedSearch: [],
    OpportunityAdvancedSearchRequest: "",
    ServiceMonitorFields: [],
    ExportOpportunitiesModal: {
      ShowModal: false,
      Request: null
    }
  };
}

const state = initialState();

const getters = {
  OpportunityFields: function(state) {
    return state.OpportunityFields;
  },
  OpportunityAdvancedSearch: function(state) {
    return state.OpportunityAdvancedSearch;
  },
  OpportunityAdvancedSearchRequest: function(state) {
    return state.OpportunityAdvancedSearchRequest;
  },
  ServiceMonitorFields: function() {
    return state.ServiceMonitorFields;
  }
};

const actions = {
  getOpportunityFields(context) {
    return new Promise((resolve, reject) => {
      if (state.OpportunityFields && state.OpportunityFields.length > 0) {
        resolve(state.OpportunityFields);
        return;
      }

      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("GET", "/api/opportunities/OpportunityFields")
        .then(resp => {
          if (resp && resp.data) {
            context.commit(
              "updateOpportunityFields",
              resp.data.data ? resp.data.data : []
            );
            resolve(resp.data.data);
          } else reject(resp);
        });
    });
  },
  async getServiceMonitorFields(context) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "GET",
      "/crm/contacts/service/service_monitor_fields"
    );
    if (response && response.data)
      context.commit(
        "updateServiceMonitorFields",
        response.data.data ? response.data.data : []
      );
    else context.commit("updateOpportunityFields", []);
    return response && response.data ? response.data.data : [];
  },
  recordPrintActivity: function(context, payload) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("POST", "/api/opportunities/print_search", payload)
        .then(response => {
          if (response && response.data && response.data.successful)
            resolve(response.data);
          else reject(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getOpportunitiesDashboardSearchResults: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let scope = request.platformIds
        ? request.platformIds
        : request.accountPlatformId
        ? [request.accountPlatformId]
        : [];
      client
        .ProcessRequest("POST", "/api/opportunities/search", request, scope)
        .then(async (response) => {
          if (response && response.data && response.data.successful) {
            response.data = mapResponse(response.data);
            resolve(response.data);
          }
          else reject(response);
        })
        .catch(function(error) {
          console.log(error)
          reject(error);
        });
    });
  },
  async getServiceMonitorSearchResults(context, request) {
    let client = new CXMApiClient();
    let scope = request.platformIds
      ? request.platformIds
      : request.accountPlatformId
      ? [request.accountPlatformId]
      : [];
    let response = await client.ProcessRequest(
      "POST",
      "/crm/contacts/service/repair_orders",
      request,
      scope
    );
    return response && response.data ? response.data : [];
  },
  async getRepairOrdersCSV(context, request) {
    let client = new CXMApiClient();
    let scope = request.platformIds
      ? request.platformIds
      : request.accountPlatformId
      ? [request.accountPlatformId]
      : [];
    let response = await client.ProcessRequest(
      "POST",
      "/crm/contacts/service/repair_orders/csv_export",
      request,
      scope
    );
    return response && response.data ? response.data : [];
  },
  getCachedOpportunitiesDashboardSearchResults: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "POST",
          "/api/opportunities/campaign/cached_results",
          request
        )
        .then(response => {
          if (response && response.data && response.data.successful)
            resolve(response.data);
          else reject(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getTaggedOpportunitiesDashboardResults: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("POST", "/api/opportunities/GetTagsSummary", request)
        .then(response => {
          if (response && response.data && response.data.successful)
            resolve(response.data);
          else reject(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getOpportunitiesByWidget: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("POST", "/api/opportunities/GetSummary", request)
        .then(response => {
          if (response && response.data && response.data.successful)
            resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getOpportunitiesDashboardExportResults: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let exportFormat = "csv";
      client
        .ProcessRequest(
          "POST",
          "/api/opportunities/export/" + exportFormat,
          request
        )
        .then(response => {
          if (response && response.data && response.status == 200) {
            let replaceFalse = response.data.replaceAll("False", "No");
            let replaceTrue = replaceFalse.replaceAll("True", "Yes");
            response.data = replaceTrue;
            resolve(csv.processCSV(response));
          } else reject(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  async submitOpportunitiesExportRequest(context, request) {
    let client = new CXMApiClient();
    return await client.ProcessRequest(
      "POST",
      "/api/opportunities/export/async",
      request
    ).catch(err => err.response);
  },
  saveOpportuntiesSearchPersonalSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest("POST", "/api/opportunities/personal_search", request)
      .catch(err => err.response);
  },
  saveOpportuntiesSearchSharedSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest("POST", "/api/opportunities/shared_search", request)
      .catch(err => err.response);
  },
  saveOpportunitiesSearchPreDefinedSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest("POST", "/api/opportunities/predefined_search", request)
      .catch(err => err.response);
  },
  getSummaryActionGroupCounts: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "POST",
          "/api/opportunities/getsummaryactiongroupcounts",
          request
        )
        .then(response => {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getOpportunitiesSearchPersonalSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "POST",
        "/api/opportunities/personal_search/list",
        request
      )
      .catch(err => err.response);
  },
  deleteOpportunitiesSearchCampaignSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client.ProcessRequest(
      "DELETE",
      `/api/opportunities/campaign_search/${request.searchId}`
    );
  },
  deleteOpportunitiesSearchPersonalSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "DELETE",
        `/api/opportunities/personal_search/${request.searchId}`
      )
      .catch(err => err.response);
  },
  convertOpportunitiesPersonalSearchToSharedSearch: async function(
    context,
    request
  ) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "POST",
        `/api/opportunities/personal_search/${request.searchId}/convert_to_shared_search`
      )
      .catch(err => err.response);
  },
  getOpportunitiesSearchSharedSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest("POST", "/api/opportunities/shared_search/list", request)
      .catch(err => err.response);
  },
  deleteOpportunitiesSearchSharedSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client.ProcessRequest(
      "DELETE",
      `/api/opportunities/shared_search/${request.searchId}`
    );
  },
  convertOpportunitiesSharedSearchToPersonalSearch: async function(
    context,
    request
  ) {
    let client = new CXMApiClient();
    return await client.ProcessRequest(
      "POST",
      `/api/opportunities/shared_search/${request.searchId}/convert_to_personal_search`
    );
  },
  getOpportunitiesSearchPreDefinedSearch: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "POST",
        "/api/opportunities/predefined_search/list",
        request
      )
      .catch(err => err.response);
  },
  getPersonalSearchById: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "GET",
        `/api/opportunities/personal_search/${request.searchId}`,
        null,
        [request.accountPlatformId]
      )
      .catch(err => err.response);
  },
  getSharedSearchById: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "GET",
        `/api/opportunities/shared_search/${request.searchId}`,
        null,
        [request.accountPlatformId]
      )
      .catch(err => err.response);
  },
  getPreDefinedSearchById: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "GET",
        `/api/opportunities/predefined_search/${request.searchId}`,
        null,
        [request.accountPlatformId]
      )
      .catch(err => err.response);
  },
  getBulkEmailStatusForPlatform: function(content, platformId) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "GET",
          "/api/opportunity/actions/email/bulk/account_platform_status/" +
            platformId
        )
        .then(response => {
          resolve(response && response.data ? response.data.data : null);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  sendBulkEmails: function(context, payload) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "POST",
          "/api/opportunity/actions/email/bulk/queue",
          payload
        )
        .then(response => {
          resolve(response && response.data ? response.data.data : null);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  sendBulkPdfs: function(context, payload) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "POST",
          "/api/opportunity/actions/email/bulk/printtopdf",
          payload
        )
        .then(response => {
          resolve(response && response.data ? response.data.data : null);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  sendBulkAutoAssist: async function(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "POST",
        "/api/opportunity/actions/auto_assistant/bulk/queue",
        request
      )
      .catch(err => err.response);
  },
  getDealerTags(context, platformIds) {
    return new Promise((resolve, reject) => {
      const client = new CXMApiClient();
      const requestPayload = {
        accountPlatformIds: platformIds,
        textSearch: null
      };

      client
        .ProcessRequest(
          "POST",
          "/api/opportunities/getdealertags",
          requestPayload
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data || []);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  runCampaignSearch(context, searchId) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest("POST", `/api/opportunities/campaign/${searchId}/run`)
        .then(response => {
          resolve(response && response.data ? response.data : null);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  searchForReassignment(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "POST",
          `/api/opportunities/search_for_reassignment`,
          request,
          [request.accountPlatformId]
        )
        .then(response => {
          resolve(response && response.data ? response.data : null);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  openExportOpportunitiesModal(context, request) {
    context.commit("openExportOpportunitiesModal", request);
  },
  closeExportOpportunitiesModal(context) {
    context.commit("closeExportOpportunitiesModal");
  }
};

const mutations = {
  updateOpportunityFields: function(state, data) {
    state.OpportunityFields = data;
  },
  updateServiceMonitorFields: function(state, data) {
    state.ServiceMonitorFields = data;
  },
  updateOpportunityAdvancedSearch: function(state, data) {
    state.OpportunityAdvancedSearch = data;
  },
  updateAdvancedOpportunitiesSearchRequest: function(state, data) {
    state.OpportunityAdvancedSearchRequest = data;
  },
  openExportOpportunitiesModal(state, request) {
    state.ExportOpportunitiesModal.Request = request;
    state.ExportOpportunitiesModal.ShowModal = true;
  },
  closeExportOpportunitiesModal(state) {
    state.ExportOpportunitiesModal.ShowModal = false;
    state.ExportOpportunitiesModal.Request = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Opportunities.js